import React, {Component} from 'react';
import {connect} from 'react-redux';
import './css/AboutUs.styl';
import Amenities from './Amenities';
import Map from '../../Shared/Map';
import Details from './Details';
import Header from '../../../../../shared/library/Header/Header';
import VisitWebsiteLink from '../../Shared/VisitWebsiteLink';
import PropTypes from 'prop-types';
import {getMapUrl} from '../../../../../shared/utilities/urlHelpers';

export class AboutUs extends Component {
  renderAttributes(attributes) {
    if (attributes) {
      const capitalizeIf = (value, fallBack) => {
        if (value.toLowerCase() === fallBack.toLowerCase()) {
          return value.toUpperCase();
        }
        return value;
      };

      const cleanedData = attributes.map(attr => {
        switch (attr.category) {
          case 'Detail':
            return {
              ...attr,
              value: capitalizeIf(attr.value, 'N/A') || 'N/A',
              name: attr.name || 'Error Loading',
            };
          case 'Amenity':
            return {
              ...attr,
              name: attr.name || 'Error Loading',
            };
          default:
            return {...attr};
        }
      });

      const filterAttributes = query =>
        cleanedData.filter(attribute => attribute.category === query);

      return (
        <div>
          <Details details={filterAttributes('Detail')} />
          <Amenities amenities={filterAttributes('Amenity')} />
        </div>
      );
    }

    return null;
  }

  render() {
    const {isPremium, attributesData: attributes} = this.props.funeralHome;
    const address1 = this.props.funeralHome.profileData.address1;
    const city = this.props.funeralHome.location.city.fullName;
    const state = this.props.funeralHome.location.state.fullName;
    const postalCode = this.props.funeralHome.location.postalCode;
    const {profileData, logoImageUrl, primaryImageUrl} = this.props.funeralHome;
    const {websiteUrl} = profileData;
    const description = profileData && profileData.description;
    const googleMapsAddressLink = getMapUrl(
      `${address1}+${city}+${state}+${postalCode}`
    );
    const logo = logoImageUrl ? (
      <img className="logo" src={logoImageUrl} />
    ) : null;
    const fhpic = primaryImageUrl ? (
      <img className="fhpic" src={primaryImageUrl} />
    ) : null;
    const imageContainer =
      logo || fhpic ? (
        <div className="about-us-tab__image">
          {fhpic}
          {logo}
        </div>
      ) : null;

    return (
      <div className="about-us-tab__container">
        <Header title="About Us" />
        {isPremium && <Map href={googleMapsAddressLink} />}
        <div className="about-us-tab__description-image-container">
          <div className="about-us-tab__description">
            {description
              .split('\n')
              .map(
                (paragraph, index) =>
                  paragraph && <p key={index}>{paragraph}</p>
              )}
            <VisitWebsiteLink websiteUrl={websiteUrl} />
            {!isPremium && (
              <p>
                Is this your business?{' '}
                <a href="https://cloud.alerts.legacy.com/fhd-update">
                  Update this page
                </a>
                .
              </p>
            )}
          </div>
          {imageContainer}
        </div>
        {this.renderAttributes(attributes)}
      </div>
    );
  }
}

AboutUs.propTypes = {
  funeralHome: PropTypes.object.isRequired,
  planning: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  planning: state.planningStore.isPlanning,
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/index.js